import React, {ReactElement} from 'react';
import {Alignment, LinkProp} from '../../../../types';
import DynamicLink from '../../../DynamicLink/DynamicLink';
import Headers, {HeaderType} from '../../Text/Headers/Headers';
import './FooterColumn.scss';

interface Props {
  columnTitle: string;
  links: LinkProp[];
}

function FooterColumn({columnTitle, links}: Props): ReactElement {
  return (
    <div className="footerColumn">
      <Headers alignment={Alignment.LEFT} headerType={HeaderType.H3}>
        {columnTitle}
      </Headers>
      <ul>
        {links.map((mapLink) => {
          return (
            <li key={mapLink.label}>
              <DynamicLink href={mapLink.href} className="unstyledLink">
                {mapLink.label}
              </DynamicLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default FooterColumn;
